import * as React from 'react';
import { Route } from 'react-router';

export default (
  <Route
    key="my/buying/lp_auctions"
    path="my/buying/lp_auctions"
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/discovery/auctions/my_auctions_container').default);
        },
        'auctions',
      );
    }}
  />
);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/routes/my_auctions.tsx